module.exports = __webpack_public_path__ + "static/media/gp5.e1771a7f.webp";